// extracted by mini-css-extract-plugin
export default {"main":"components-general-page-main-module__main","smart-insights-open":"components-general-page-main-module__smart-insights-open"};